/* eslint-disable react/react-in-jsx-scope */
import { ERROR_CODES } from './Errors';

const { AGENCY_PROFESSIONAL_ERROR_CODES } = ERROR_CODES;

const MESSAGE_MAP = {
	[AGENCY_PROFESSIONAL_ERROR_CODES.SUCCESS]:
		'This professional is new to our network. Continue creating their account to add them to your agency.',
	[AGENCY_PROFESSIONAL_ERROR_CODES.CONTACT_US]: (
		<>
			This email and/or cell phone number already exists for another professional. If you’re still having issues after
			checking both fields, contact <a href="mailto:agencysupport@shiftmed.com">agencysupport@shiftmed.com</a> for
			further assistance.
		</>
	),
	[AGENCY_PROFESSIONAL_ERROR_CODES.ALREADY_EXISTS]: (
		<>
			This professional has already been added to your agency. Click on <strong>Back to Professionals</strong> to see
			them in your roster.
		</>
	)
};

export default MESSAGE_MAP;
